import {Text, TextField} from '@/components/atoms'
import {FC} from 'react'
import {RewardItemProps} from './RewardItem'
import {useRewardPoints} from './useRewardPoints'

export const RewardPoints: FC<RewardItemProps> = ({promotionCondition, rewardIndex = 0}) => {
  const {pointsValue, isError, handlePointsChange} = useRewardPoints({promotionCondition, rewardIndex})

  return (
    <>
      <TextField
        updateValue={handlePointsChange}
        value={pointsValue}
        error={isError ? 'Value Invalid' : ''}
        uiSchema={{
          helperText: '',
          placeholder: '0',
        }}
        // @ts-ignore
        style={{maxWidth: '400px'}}
        type="number"
      />
      <Text>{'points.'}</Text>
    </>
  )
}
